export default __webpack_public_path__ + "static/media/TL13.2.d7bb1076.mp3";